import {
  Group,
  Button,
  Box,
  Menu,
  Avatar,
  Text,
  Skeleton,
  Image,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';
import { useAuth } from '../hooks/useAuth';
import { useMediaQuery } from '@mantine/hooks';

export default function Header() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, isAuthenticated, isLoading, login, logout } = useAuth();

  const isMobile = useMediaQuery('(max-width: 600px)');

  return (
    <Box
      component="header"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 70,
        background: '#FAFBFC',
        borderBottom: '1px solid #E0E0E0',
        zIndex: 100,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
      }}
    >
      <Group h="100%" px="md" justify="space-between">
        <Group
          gap="xs"
          onClick={() => navigate(isAuthenticated ? '/app/dashboard' : '/')}
          style={{ cursor: 'pointer' }}
        >
          <Image
            src="/strassenwaechter-logo.png"
            alt="Straßenwächter e.V."
            height={70}
          />
        </Group>
        <Group justify="space-between" gap="md">
          <LanguageSwitcher />
          {isLoading ? (
            <Skeleton height={36} width={100} radius="sm" />
          ) : isAuthenticated && user ? (
            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Group gap="xs">
                  <Avatar
                    src={user.picture ?? null}
                    alt={user.name || user.email}
                    radius="xl"
                    h="xl"
                  />
                  {isMobile ? null : <Text>{user.name || user.email}</Text>}
                </Group>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Label>{user.name}</Menu.Label>
                <Menu.Divider />
                <Menu.Item onClick={() => navigate('/app/profile')}>
                  {t('profile.title')}
                </Menu.Item>
                <Menu.Item color="red" onClick={logout}>
                  {t('header.logout')}
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          ) : (
            <Button variant="filled" onClick={login}>
              {t('header.login')}
            </Button>
          )}
        </Group>
      </Group>
    </Box>
  );
}
